import PptxGenJS from 'pptxgenjs';
import PowerPointSlideProcessor from '@app/services/export/ppt/slides/PowerPointSlideProcessor';
import IWelcomeSlideData from '@app/types/data/slides/IWelcomeSlideData';
import { createLogoForSlide } from '@app/services/export/ppt/utils/layoutUtils';
import { copyBold, h1 } from '@app/services/export/ppt/variables/typography';
import { removeHtmlInString } from '@app/services/export/ppt/utils/formattingUtils';
import { colors, presentationDimensions } from '@app/services/export/ppt/variables/constants';

export default class PowerPointWelcomeSlideProcessor extends PowerPointSlideProcessor<IWelcomeSlideData> {
	public async processSlideData(): Promise<void> {
		const slide: PptxGenJS.Slide = this.presentation.addSlide();
		const imageHeight = 2.43;

		slide.addImage({
			path: 'assets/images/ppt-gradient-bg.jpg',
			x: 0,
			y: 0,
			w: '100%',
			h: '100%'
		});

		slide.addImage({
			path: 'assets/images/jungfrau-cutout2x.png',
			x: 0,
			y: presentationDimensions.h - imageHeight,
			w: presentationDimensions.w,
			h: imageHeight
		});

		slide.addText(this.slideData.overline.toLocaleUpperCase(), {
			...copyBold,
			x: '10%',
			y: 1.28,
			w: '80%',
			h: 0.3,
			color: colors.white,
			align: 'center'
		});

		slide.addText(this.slideData.headline.toLocaleUpperCase(), {
			...h1,
			x: 0,
			y: 1.57,
			w: '100%',
			h: 0.81,
			color: colors.white,
			align: 'center'
		});

		slide.addText(removeHtmlInString(this.slideData.copy), {
			...copyBold,
			x: '20%',
			y: 2.37,
			w: '60%',
			h: 2,
			valign: 'top',
			color: colors.white,
			align: 'center'
		});

		createLogoForSlide(slide);
	}
}
